import { createUseStyles } from 'react-jss';

export default createUseStyles({
  modal: {
    '& .ant-modal-body': {
      maxHeight: '80vh',
      minHeight: '80vh',
      padding: '0px !important',
      display: 'flex',
    },
  },
});
